import { EXAMPLE_IDS } from './example-ids.js';
import { EXAMPLE_ANSWER_IDS, EXAMPLE_NOW } from './examples.js';
const ids = EXAMPLE_IDS;
/** The NPC view: a table of the NPCs whose loyalty is at least 30, by title, pinned. */
export const EXAMPLE_VIEW_LOYAL_NPCS = {
    id: ids.viewLoyalNpcs.id,
    rv: 1,
    name: 'Loyal NPCs',
    typeKey: 'npc',
    layout: 'table',
    query: {
        filters: [{ column: 'loyalty', op: 'gte', value: 30 }],
        sort: [{ column: 'title', direction: 'asc' }],
        limit: 50,
    },
    columns: ['title', 'loyalty'],
    pinnedItemId: ids.sidebarPinViewLoyalNpcs.id,
    createdAt: EXAMPLE_NOW,
    updatedAt: EXAMPLE_NOW,
};
/** The quest view: every quest as a list, by title, with the type's default columns. */
export const EXAMPLE_VIEW_QUEST_BOARD = {
    id: ids.viewQuestBoard.id,
    rv: 1,
    name: 'Quest board',
    typeKey: 'quest',
    layout: 'list',
    query: { filters: [], sort: [{ column: 'title', direction: 'asc' }], limit: 50 },
    columns: [],
    pinnedItemId: null,
    createdAt: EXAMPLE_NOW,
    updatedAt: EXAMPLE_NOW,
};
/** `views.create`'s answer: the drafts among the NPCs, as a table, unpinned. */
export const EXAMPLE_VIEW_CREATED = {
    id: EXAMPLE_ANSWER_IDS.savedViewCreated,
    rv: 1,
    name: 'Draft NPCs',
    typeKey: 'npc',
    layout: 'table',
    query: {
        filters: [{ column: 'canonStatus', op: 'eq', value: 'draft' }],
        sort: [{ column: 'title', direction: 'asc' }],
        limit: 50,
    },
    columns: ['title', 'canonStatus'],
    pinnedItemId: null,
    createdAt: EXAMPLE_NOW,
    updatedAt: EXAMPLE_NOW,
};
/** The NPC view's pin: a sidebar item of kind `view` at the top level, after the prep group. */
export const EXAMPLE_VIEW_PIN = {
    id: ids.sidebarPinViewLoyalNpcs.id,
    parentId: null,
    kind: 'view',
    refId: ids.viewLoyalNpcs.id,
    label: null,
    sortKey: 'a2',
};
//# sourceMappingURL=examples-views.js.map